import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ProductDtDemoData } from '../../../../../data/ProductDtDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ApiGetServiceDetails } from '../ServiceOperation';

const ServiceDetailsContext = createContext();
export const useServiceDt = () => useContext(ServiceDetailsContext);

function ServiceDetailsProvider({ children, serviceId }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [serviceInfo, setServiceInfo] = useState(ProductDtDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    // -- set package info
    const [packageInfo, setPackageInfo] = useState(ProductDtDemoData?.packages?.[0]);
    // -- set if any package is selected
    const [packageId, setPackageId] = useState(0);

    // -- set true/false if any package is selected
    const [isClicked, setIsClicked] = useState(0);

    const { setMessage } = useTemplate();

    // -- Load invoice info by invoiceId
    useEffect(() => {
        ApiGetServiceDetails(serviceId)
            .then(({ data }) => {
                setServiceInfo(data.service);
                // set Package info if any package is selected
                const prevData = data?.service?.packages?.find((d) => d?.id === packageId);
                setPackageInfo(prevData);
            })
            .catch((err) => {
                setServiceInfo({});
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, serviceId, reloadKey, packageId]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setServiceInfo(ProductDtDemoData);
            setPackageInfo(ProductDtDemoData?.packages?.[0]);
        };

        // --Handle Package item click
        const handleSelectPackage = (ev, item) => {
            ev.stopPropagation();
            ev.preventDefault();
            setPackageInfo(item);
            setPackageId(item?.id);
            setIsClicked((st) => !st);
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,
            handleSelectPackage,
            isSelected: packageId > 0,
            // -- invoice info
            serviceInfo,
            setServiceInfo,

            // --set package info
            packageInfo,
            setPackageInfo,
            isClicked,

            // All Handler
            handleReload
        };
    }, [isClicked, packageId, packageInfo, serviceInfo, showModal?.data, showModal?.type]);

    return (
        <ServiceDetailsContext.Provider value={value}>{children}</ServiceDetailsContext.Provider>
    );
}

export default ServiceDetailsProvider;
